import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';




function * createSmtpLogin(data){
  try{
     const api = yield call([axios, axios.post], '/api/email/smtp_logins', data.payload)
     yield put({type:'REQUEST_CREATE_SMTP_LOGIN_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateSmtpLogin(data){
  try{
     const api = yield call([axios, axios.put], '/api/email/smtp_logins/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_SMTP_LOGIN_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteSmtpLogin(data){
  try{
     const api = yield call([axios, axios.delete], '/api/email/smtp_logins/'+data.id)
     yield put({type:'REQUEST_DELETE_SMTP_LOGIN_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexHubspotCallDispositions(data){
  try{
     const api = yield call([axios, axios.get], '/api/hubspot/callDispositions')
     yield put({type:'REQUEST_INDEX_HUBSPOT_CALL_DISPOSITIONS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexExternalCrmOwners(data){
  try{
     const api = yield call([axios, axios.get], '/api/externalCrms/'+data.crm_login_id+'/owners')
     if(api.data==undefined || api.data==null){yield put({type:'REQUEST_INDEX_EXTERNAL_CRM_OWNERS'})}
     else{yield put({type:'REQUEST_INDEX_EXTERNAL_CRM_OWNERS_SUCCESS', val:api.data, crm_login_id:data.crm_login_id})}
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateExternalCrmOwners(data){
  try{
     const api = yield call([axios, axios.put], '/api/externalCrms/owners/update', data.payload)
     yield put({type:'REQUEST_UPDATE_EXTERNAL_CRM_OWNERS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateHubspotCallDispositions(data){
  try{
     const api = yield call([axios, axios.put], '/api/externalCrms/callDispositions/update', data.payload)
     yield put({type:'REQUEST_UPDATE_HUBSPOT_CALL_DISPOSITIONS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateExternalCrmSetup(data){
  try{
     const api = yield call([axios, axios.put], '/api/externalCrms/setup/update', data.payload)
     yield put({type:'REQUEST_UPDATE_EXTERNAL_CRM_SETUP_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * disconnectHubspot(data){
  try{
     const api = yield call([axios, axios.put], '/api/hubspot/disconnect')
     yield put({type:'REQUEST_HUBSPOT_DISCONNECT_SUCCESS'});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getGmailAddresses(data){
  try{
     const api = yield call([axios, axios.get], '/api/gmail/addresses')
     yield put({type:'REQUEST_GET_GMAIL_ADDRESSES_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getGmailSetup(data){
  try{
     const api = yield call([axios, axios.get], '/api/gmail/setup')
     yield put({type:'REQUEST_GET_GMAIL_SETUP_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * updateEmailSetup(data){
  try{
     const api = yield call([axios, axios.put], '/api/email/setup', data.payload)
     yield put({type:'REQUEST_UPDATE_EMAIL_SETUP_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * createMarketingEmailDomain(data){
  try{
     const api = yield call([axios, axios.post], '/api/marketing_email/create_domain', data.payload)
     yield put({type:'REQUEST_CREATE_MARKETING_DOMAIN_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}



function * connectEmail(data){
  try{
     const api = yield call([axios, axios.post], '/api/email/connect')
     yield put({type:'REQUEST_EMAIL_CONNECT_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * disconnectGmail(data){
  try{
     const api = yield call([axios, axios.put], '/api/gmail/disconnect')
     yield put({type:'REQUEST_GMAIL_DISCONNECT_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * readGmailMessage(data){
  try{
     const api = yield call([axios, axios.put], '/api/gmail/read_message/'+data.gmail_id)
     if(api.data.timeline_item!=undefined){api.data.timeline_item.company_id=data.company_id;}
     yield put({type:'REQUEST_TIMELINE_ITEM_UPDATE_READ_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');console.log(error); yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * authorizeGmailContact(data){
  try{
     const api = yield call([axios, axios.post], '/api/gmail/authorize/'+data.contact_id)
     yield put({type:'REQUEST_AUTHORIZE_GMAIL_CONTACT_SUCCESS', val:api.data, company_id:data.company_id})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getEmailSignatures(data){
  try{
     const api = yield call([axios, axios.get], '/api/email/signatures')
     yield put({type:'REQUEST_GET_EMAIL_SIGNATURES_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createEmailAddress(data){
  try{
     const api = yield call([axios, axios.post], '/api/email/addresses', data.payload)
     yield put({type:'REQUEST_CREATE_EMAIL_ADDRESS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateEmailAddress(data){
  try{
     const api = yield call([axios, axios.put], '/api/email/addresses/'+data.payload.id, data.payload)
     yield put({type:'REQUEST_UPDATE_EMAIL_ADDRESS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateEmailUnsubscribeMessage(data){
  try{
     const api = yield call([axios, axios.put], '/api/email/unsubscribeMessage', data.payload)
     yield put({type:'REQUEST_UPDATE_EMAIL_UNSUBSCRIBE_MESSAGE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteEmailAddress(data){
  try{
     const api = yield call([axios, axios.delete], '/api/email/addresses/'+data.id)
     yield put({type:'REQUEST_DELETE_EMAIL_ADDRESS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * getWebhooks(data){
  try{
     const api = yield call([axios, axios.get], '/api/developers/webhooks')
     yield put({type:'REQUEST_GET_WEBHOOKS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createWebhooks(data){
  try{
     const api = yield call([axios, axios.post], '/api/developers/webhooks', data.payload)
     yield put({type:'REQUEST_CREATE_WEBHOOKS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWebhooks(data){
  try{
     const api = yield call([axios, axios.put], '/api/developers/webhooks/'+data.payload.id, data.payload)
     yield put({type:'REQUEST_UPDATE_WEBHOOKS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteWebhooks(data){
  try{
     const api = yield call([axios, axios.delete], '/api/developers/webhooks/'+data.id)
     yield put({type:'REQUEST_DELETE_WEBHOOKS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * updateEmailEnrichment(data){
  try{
     const api = yield call([axios, axios.put], '/api/emailEnrichment/api_keys/', data.payload)
     yield put({type:'REQUEST_UPDATE_EMAIL_ENRICHMENT_API_KEYS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getEmailEnrichment(data){
  try{
     const api = yield call([axios, axios.get], '/api/emailEnrichment/api_keys')
     yield put({type:'REQUEST_GET_EMAIL_ENRICHMENT_API_KEYS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}



function * indexApiKeys(data){
  try{
     const api = yield call([axios, axios.get], '/api/developers/api_keys', data.payload)
     yield put({type:'REQUEST_INDEX_API_KEYS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createApiKey(data){
  try{
     const api = yield call([axios, axios.post], '/api/developers/api_keys', data.payload)
     yield put({type:'REQUEST_CREATE_API_KEY_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateApiKey(data){
  try{
     const api = yield call([axios, axios.put], '/api/developers/api_keys/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_API_KEY_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteApiKey(data){
  try{
     const api = yield call([axios, axios.delete], '/api/developers/api_keys/'+data.id)
     yield put({type:'REQUEST_DELETE_API_KEY_SUCCESS', val:{id:data.id}});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function* Index_api_keys(){yield takeEvery('REQUEST_INDEX_API_KEYS', indexApiKeys);}
function* Create_api_key(){yield takeEvery('REQUEST_CREATE_API_KEY', createApiKey);}
function* Update_api_key(){yield takeEvery('REQUEST_UPDATE_API_KEY', updateApiKey);}
function* Delete_api_key(){yield takeEvery('REQUEST_DELETE_API_KEY', deleteApiKey);}

function* Connect_email(){yield takeEvery('REQUEST_CONNECT_EMAIL', connectEmail);}
function* Disconnect_gmail(){yield takeEvery('REQUEST_GMAIL_DISCONNECT', disconnectGmail);}

function* Index_hubspot_call_dispositions(){yield takeEvery('REQUEST_INDEX_HUBSPOT_CALL_DISPOSITIONS', indexHubspotCallDispositions);}
function* Index_external_crm_owners(){yield takeEvery('REQUEST_INDEX_EXTERNAL_CRM_OWNERS', indexExternalCrmOwners);}
function* Update_hubspot_call_dispositions(){yield takeEvery('REQUEST_UPDATE_HUBSPOT_CALL_DISPOSITIONS', updateHubspotCallDispositions);}
function* Get_gmail_addresses(){yield takeEvery('REQUEST_GET_GMAIL_ADDRESSES', getGmailAddresses);}
function* Get_gmail_setup(){yield takeEvery('REQUEST_GET_GMAIL_SETUP', getGmailSetup);}
function* Authorize_gmail_contact(){yield takeEvery('REQUEST_AUTHORIZE_GMAIL_CONTACT', authorizeGmailContact);}
function* Update_email_setup(){yield takeEvery('REQUEST_UPDATE_EMAIL_SETUP', updateEmailSetup);}
function* Read_email_message(){yield takeEvery('REQUEST_READ_EMAIL_MESSAGE', readGmailMessage);}
function* Update_email_unsubscribe_message(){yield takeEvery('REQUEST_UPDATE_EMAIL_UNSUBSCRIBE_MESSAGE', updateEmailUnsubscribeMessage);}

function* Create_marketing_email_domain(){yield takeEvery('REQUEST_CREATE_MARKETING_DOMAIN', createMarketingEmailDomain);}

function* Update_external_crm_owners(){yield takeEvery('REQUEST_UPDATE_EXTERNAL_CRM_OWNERS', updateExternalCrmOwners);}
function* Update_external_crm_setup(){yield takeEvery('REQUEST_UPDATE_EXTERNAL_CRM_SETUP', updateExternalCrmSetup);}
function* Disconnect_hubspot(){yield takeEvery('REQUEST_HUBSPOT_DISCONNECT', disconnectHubspot);}

function* Create_smtp_login(){yield takeEvery('REQUEST_CREATE_SMTP_LOGIN', createSmtpLogin);}
function* Update_smtp_login(){yield takeEvery('REQUEST_UPDATE_SMTP_LOGIN', updateSmtpLogin);}
function* Delete_smtp_login(){yield takeEvery('REQUEST_DELETE_SMTP_LOGIN', deleteSmtpLogin);}

function* Get_email_signatures(){yield takeEvery('REQUEST_GET_EMAIL_SIGNATURES', getEmailSignatures);}
function* Create_email_address(){yield takeEvery('REQUEST_CREATE_EMAIL_ADDRESS', createEmailAddress);}
function* Update_email_address(){yield takeEvery('REQUEST_UPDATE_EMAIL_ADDRESS', updateEmailAddress);}
function* Delete_email_address(){yield takeEvery('REQUEST_DELETE_EMAIL_ADDRESS', deleteEmailAddress);}

function* Get_webhooks(){yield takeEvery('REQUEST_GET_WEBHOOKS', getWebhooks);}
function* Create_webhooks(){yield takeEvery('REQUEST_CREATE_WEBHOOKS', createWebhooks);}
function* Update_webhooks(){yield takeEvery('REQUEST_UPDATE_WEBHOOKS', updateWebhooks);}
function* Delete_webhooks(){yield takeEvery('REQUEST_DELETE_WEBHOOKS', deleteWebhooks);}


function* Update_email_enrichment(){yield takeEvery('REQUEST_UPDATE_EMAIL_ENRICHMENT_API_KEYS', updateEmailEnrichment);}
function* Get_email_enrichment(){yield takeEvery('REQUEST_GET_EMAIL_ENRICHMENT_API_KEYS', getEmailEnrichment);}



export default function* Root_lists(){
  yield all([
    fork(Authorize_gmail_contact),
    fork(Connect_email),
    fork(Disconnect_gmail),
    fork(Get_gmail_setup),
    fork(Get_gmail_addresses),
    fork(Update_email_setup),
    fork(Read_email_message),
    fork(Update_email_unsubscribe_message),
    fork(Index_hubspot_call_dispositions),
    fork(Update_hubspot_call_dispositions),
    fork(Index_external_crm_owners),
    fork(Update_external_crm_owners),
    fork(Update_external_crm_setup),
    fork(Disconnect_hubspot),
    fork(Create_smtp_login),
    fork(Update_smtp_login),
    fork(Delete_smtp_login),
    fork(Get_email_signatures),
    fork(Update_email_address),
    fork(Create_email_address),
    fork(Delete_email_address),
    fork(Get_webhooks),
    fork(Update_webhooks),
    fork(Create_webhooks),
    fork(Delete_webhooks),
    fork(Update_email_enrichment),
    fork(Get_email_enrichment),
    fork(Create_marketing_email_domain),

    fork(Index_api_keys),
    fork(Create_api_key),
    fork(Update_api_key),
    fork(Delete_api_key)
  ])}
